// hooks/useHandleDragEnd.js

import { useCallback } from "react";
import { arrayMove } from '@dnd-kit/sortable'; // you can also write your own

const useHandleDragEnd = (fields, update) => {
  return useCallback(
    (event) => {
      const { active, over } = event;
      if (!over || active.id === over.id) return;

      const oldIndex = fields.findIndex((f) => f.id === active.id);
      const newIndex = fields.findIndex((f) => f.id === over.id);
      if (oldIndex === -1 || newIndex === -1) return;

      // Extract only image-related data
      const imageFields = fields.map(({ file,isRoof, previewUrl, uploadProgress, uploading, serverId, cancelUpload }) => ({
        file,
        isRoof,
        previewUrl,
        uploadProgress,
        uploading,
        serverId,
        cancelUpload,
      }));

      // Reorder image-related data
      const reordered = arrayMove(imageFields, oldIndex, newIndex);

      // Update each index's image data back
      reordered.forEach((imgData, i) => {
        update(i, {
          ...fields[i], // preserve label & isLabelCustom
          ...imgData,   // overwrite image data
        });
      });
    },
    [fields, update]
  );
};

export default useHandleDragEnd;
